import axios from "axios";

const KEY = "AIzaSyCMCzAUCOsulr2FrLi64_H5k1jQmqJRQaM";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3/",
  //THIS IS CALLED A QUERY STRING BELOW..
  params: {
    part: "snippet",
    maxResults: 5,
    key: KEY,
  },
});
